import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  table: {
    title: null,
    headers: [
      { text: 'Seller', value: 'seller', sortable: false },
      { text: 'Brand', value: 'brand', sortable: false },
      { text: 'Coverage', value: 'coverage', sortable: false },
      { text: 'My Min', value: 'my_min', sortable: false },
      { text: 'My Max', value: 'my_max', sortable: false },
      { text: 'Min', value: 'seller_min', sortable: false },
      { text: 'Max', value: 'seller_max', sortable: false },
      { text: 'Avg', value: 'seller_avg', sortable: false }
    ],
    items: [],
    filteredItems: [],
    loading: false,
    noData: false
  },
  filters: {
    sellers: {
      items: [],
      checked: [],
      isLoading: false
    },
    brands: {
      items: [],
      checked: [],
      isLoading: false
    }
  }
}

const getters = {

}

const actions = {
  getSellersDataDistribution ({ commit }, filter) {
    commit('SET_loading', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'sellersBrandDataDistribution',
        payload: {
          sellers: filter.sellers,
          categories: filter.categories,
          brands: filter.brands
        }
      })
        .then(response => {
          console.log('response.data.payload BRANDS', response.data.payload)
          commit('SET_title', response.data.payload.title)
          if (response.data.payload.distributions.length > 0) {
            commit('SET_tableData', response.data.payload)
            commit('SET_noData', false)
            commit('SET_loading', false)
            resolve(1)
          } else {
            commit('SET_loading', false)
            commit('SET_noData', true)
            resolve(0)
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_tableData (state, data) {
    state.table.items = data.distributions
    state.filters.sellers.items = data.sellers
    state.filters.brands.items = data.manufacturers
  },
  ADD_filters (state, data) {
    let typeParent = null
    if (data.type === 'manufacturer_id') {
      typeParent = 'brands'
    } else if (data.type === 'seller_id') {
      typeParent = 'sellers'
    } else if (data.type === 'all') {
      // Reseting
      for (let i in state.filters) {
        state.filters[i].checked = []
      }
    }
    if (data.type !== 'all') {
      state.filters[typeParent].checked = data.item
      let arr = []
      for (let index in state.table.items) {
        if ((!state.filters.sellers.checked.length || state.filters.sellers.checked.indexOf(state.table.items[index].seller_id) > -1) &&
          (!state.filters.brands.checked.length || state.filters.brands.checked.indexOf(state.table.items[index].manufacturer_id) > -1)) {
          arr.unshift(state.table.items[index])
        }
      }
      state.table.filteredItems = arr
    }
  },
  SET_loading (state, bool) {
    state.table.loading = bool
  },
  SET_noData (state, bool) {
    state.table.noData = bool
    if (bool) {
      state.table.items = []
    }
  },
  SET_title (state, data) {
    state.table.title = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/analytics/sellersBrandDistribution.js